import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface AnimatedDropdownProps {
    placeholder: string;
    options: string[];
    selected: string;
    onSelect: (option: string) => void;
}



const AnimatedDropdown: React.FC<AnimatedDropdownProps> = ({ placeholder, options, selected, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);

    const dropdownVariants = {
        open: { opacity: 1, scale: 1, transition: { staggerChildren: 0.1 } },
        closed: { opacity: 0, scale: 0.95 }
    };

    const itemVariants = {
        open: { opacity: 1, y: 0 },
        closed: { opacity: 0, y: -10 }
    };

    const arrowVariants = {
        open: { rotate: 180 },
        closed: { rotate: 0 }
    };
    return (
        <div className="relative w-full">
            <div
                className="p-4 rounded-xl border-none font-inter bg-custom-black-shade text-white placeholder-white outline-none cursor-pointer flex justify-between items-center"
                onClick={() => setIsOpen(!isOpen)}
            >
                {selected || placeholder}
                <motion.span
                    variants={arrowVariants}
                    animate={isOpen ? "open" : "closed"}
                    transition={{ duration: 0.2 }}
                >
                    ▼
                </motion.span>
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={dropdownVariants}
                        transition={{ duration: 0.5 }}
                        className="absolute z-10 bg-custom-black-shade text-white w-full mt-1 rounded-lg shadow-lg overflow-hidden overflow-y-auto max-h-64 no-scrollbar"
                    >
                        {options.map((option, index) => (
                            <motion.div
                                key={index}
                                variants={itemVariants}
                                className="p-4 cursor-pointer hover:bg-gray-700"
                                onClick={() => {
                                    onSelect(option);
                                    setIsOpen(false);
                                }}
                            >
                                {option}
                            </motion.div>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default AnimatedDropdown;
